import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  homeAPI,
  servicesAPI,
  teamAPI,
  blogAPI,
  coreValuesAPI,
  insuranceAPI,
  conditionsAPI,
  settingsAPI,
  faqAPI,
  feesAPI,
  jobListingsAPI,
} from '../services/api';

// Async thunks for fetching data
export const fetchHomeContent = createAsyncThunk('website/fetchHomeContent', async () => {
  const response = await homeAPI.get();
  return response.data;
});

export const fetchServices = createAsyncThunk('website/fetchServices', async () => {
  const response = await servicesAPI.getAll();
  return response.data;
});

export const fetchTeam = createAsyncThunk('website/fetchTeam', async () => {
  const response = await teamAPI.getAll();
  return response.data;
});

export const fetchBlog = createAsyncThunk('website/fetchBlog', async (limit) => {
  // If limit is provided, use it; otherwise default to 3 for home page
  const response = await blogAPI.getAll(limit !== undefined ? limit : 3);
  return response.data;
});

export const fetchCoreValues = createAsyncThunk('website/fetchCoreValues', async () => {
  const response = await coreValuesAPI.getAll();
  return response.data;
});

export const fetchInsurance = createAsyncThunk('website/fetchInsurance', async () => {
  const response = await insuranceAPI.getAll();
  return response.data;
});

export const fetchConditions = createAsyncThunk('website/fetchConditions', async () => {
  const response = await conditionsAPI.getAll();
  return response.data;
});

export const fetchSettings = createAsyncThunk('website/fetchSettings', async () => {
  const response = await settingsAPI.get();
  return response.data;
});

export const fetchFAQ = createAsyncThunk('website/fetchFAQ', async () => {
  const response = await faqAPI.getAll();
  return response.data;
});

export const fetchFees = createAsyncThunk('website/fetchFees', async () => {
  const response = await feesAPI.getAll();
  return response.data;
});

export const fetchJobListings = createAsyncThunk('website/fetchJobListings', async () => {
  const response = await jobListingsAPI.getAll();
  return response.data;
});

const websiteSlice = createSlice({
  name: 'website',
  initialState: {
    homeContent: null,
    services: [],
    team: [],
    blog: [],
    coreValues: [],
    insurance: [],
    conditions: [],
    faq: [],
    fees: [],
    jobListings: [],
    settings: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Home Content
      .addCase(fetchHomeContent.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHomeContent.fulfilled, (state, action) => {
        state.loading = false;
        state.homeContent = action.payload;
      })
      .addCase(fetchHomeContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Services
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.services = action.payload;
      })
      // Team
      .addCase(fetchTeam.fulfilled, (state, action) => {
        state.team = action.payload;
      })
      // Blog
      .addCase(fetchBlog.fulfilled, (state, action) => {
        state.blog = action.payload;
      })
      // Core Values
      .addCase(fetchCoreValues.fulfilled, (state, action) => {
        state.coreValues = action.payload;
      })
      // Insurance
      .addCase(fetchInsurance.fulfilled, (state, action) => {
        state.insurance = action.payload;
      })
      // Conditions
      .addCase(fetchConditions.fulfilled, (state, action) => {
        state.conditions = action.payload;
      })
      // Settings
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.settings = action.payload;
      })
      // FAQ
      .addCase(fetchFAQ.fulfilled, (state, action) => {
        state.faq = action.payload;
      })
      // Fees
      .addCase(fetchFees.fulfilled, (state, action) => {
        state.fees = action.payload;
      })
      // Job Listings
      .addCase(fetchJobListings.fulfilled, (state, action) => {
        state.jobListings = action.payload;
      });
  },
});

export default websiteSlice.reducer;
